import {Injectable} from '@angular/core';
import {ModelType} from '../3DView/Shape/modelType';
import {PolySizeService} from '../3DView/Calculation/poly-size.service';



@Injectable({
    providedIn: 'root'
})
export class ModelDataService {

    private _modelsPath = './assets/Human/Models/';
    // get and set
    private _height: number;
    private _weight: number;
    private _age: number;

    constructor(private polySizeService: PolySizeService) {
        this._type = new ModelType();
    }

    /**
     * Get age from model.
     */
    get age(): number {
        if (this._age === undefined) {
            this._age = this.age = 30;
        }

        return this._age;
    }

    private _bmi: number;

    private _typeChanged = false;
    private _type: ModelType;
    private _patientID: string;

    get bmi(): number {
        return this._bmi;
    }

    get height(): number {
        if (this._height === undefined) {
            this._height = this.height = this.polySizeService.heightCm;
        }

        return this._height;
    }

    get heightOfModelCm(): number {
        return this.polySizeService.heightCm;
    }

    set height(value: number) {
        this._height = value;
    }

    /**
     * Set age from model.
     * @param age
     */
    set age(age: number) {
        this._age = age;
    }

    /**
     * Get weight from model.
     */
    get weight(): number {
        if (this._weight === undefined) {
            this._weight = this.weight = 0;
        }

        return this._weight;
    }

    /**
     * Set weight from model.
     * @param weight
     */
    set weight(weight: number) {
        this._weight = weight;
    }

    get typeChanged(): boolean {
        return this._typeChanged;
    }


    get type(): ModelType {
        return this._type;
    }

    set bmi(value: number) {
        this._bmi = value;
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    /**
     * remove old model and load selected model
     */
    public changeModel() {
        this._typeChanged = false;
    }

    get modelsPath(): string {
        return this._modelsPath;
    }

    set patientID(value: string) {
        this._patientID = value;
    }

    set type(value: ModelType) {
        if (value !== this._type) {
            this._typeChanged = true;
        }

        this._type = new ModelType({
            Sex: value.sex,
            BodyShape: value.shape,
            AgeGroup: value.ageGroup,
            weight: this.weight
        });
        // this.containerService.modelType = value;
    }

    /**
     * returns human mesh from container service
     */
    // get modelMesh(): Mesh {
    //     return <Mesh>this.containerService.renderGroup.children[0];
    // }

    // /**
    //  * returns 3d model scale
    //  */
    // get scaleFactor(): number {
    //     return this.containerService.scalefactor;
    // }

    get patientID(): string {
        return this._patientID;
    }

    public calculateAge(birthDate: Date): number {
        let diff = (new Date().getTime() - new Date(birthDate).getTime()) / 1000;
        diff /= (60 * 60 * 24);
        this._age = (Math.abs(Math.round(diff / 365.25)));
        return this._age;
    }
}
